export default "__VITE_ASSET__LmICgelw__"